import { render } from "./ProjectDonation.vue?vue&type=template&id=42c953a7"
import script from "./ProjectDonation.vue?vue&type=script&lang=js"
export * from "./ProjectDonation.vue?vue&type=script&lang=js"
script.render = render

export default script